/************
 -- General
 ************/

function handleFaqClick(event){
  event.classList.toggle('active')
}

// localized
const productPage = document.querySelector('#product');

// quantity
let quantity = 1;

// ATC button
const productATCButton = productPage.querySelector('#productATC');

function isDiscontinuedVariant(variant) {
  if (!variant) return false;
  const discontinuedIds = Array.isArray(window.discontinuedVariantIds) ? window.discontinuedVariantIds : [];
  return discontinuedIds.includes(Number(variant.id));
}

// wait for load and check if product has been saved
document.addEventListener("DOMContentLoaded", async () => {
    // check if product is in wishlist
    const wishlist = await getWishList();
    productPage.querySelectorAll('.wishlistAdd').forEach(el => {
        const handle = el.dataset.handle;
        if (wishlist.includes(handle)) el.classList.add("active");
    })
})

/**********************
 -- Product Announcement
 **********************/

// close announcement bar
productPage.querySelector('#productAnnouncementButton')?.addEventListener('click', function () {
    this.parentElement.remove();
});

/******************
 -- Product Swiper
 ******************/
 
    // setup product swiper
const swiperContainer = document.querySelector(".productSwiper_swiper #productSwiper");

if (swiperContainer) {
    let productImages = new Swiper(".productSwiper_swiper #productSwiper", {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        zoom: {
            maxRatio: 3,
            toggle: false
        },
        on: {
            slideChange: function () {
                document.querySelector('#productSwiperImageOverlay')?.classList.remove('active');
                document.querySelectorAll('.productSwiperPlay.active')?.forEach(async active => {
                    active.classList.remove('active');
                    await active.querySelector('video')?.pause();
                });
                document.querySelectorAll("#productThumbnails .productThumbnailItem.active")
                    .forEach(el => el.classList.remove("active"));
                const slideGroup = document.querySelectorAll("#productThumbnails .productThumbnailItem");
                slideGroup[this.activeIndex]?.classList.add("active");
            }
        }
    });

    // thumbnail images for swiper
    document.querySelectorAll(".productThumbnail").forEach(function (element) {
        element.addEventListener("click", function () {
            let index = getElIndex(this.parentElement);
            productImages.slideTo(index);
        });
    });
}
else{
window.swiperScriptInitialization = function(){
let productImages = new Swiper("#productSwiper", {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        zoom: {
            maxRatio: 3,
            toggle: false
        },
        on: {
            slideChange: function () {
                // if overlay is active, remove
                document.querySelector('#productSwiperImageOverlay').classList.remove('active');
                document.querySelectorAll('.productSwiperPlay.active')?.forEach(async active => {
                    active.classList.remove('active');
                    await active.querySelector('video').pause();
                })
                // change over active class
                document.querySelectorAll("#productThumbnails .productThumbnailItem.active").forEach(el => el.classList.remove("active"));
                document.querySelectorAll("#productThumbnails .productThumbnailItem.matched-variant-thumb.activeess").forEach(el => el.classList.remove("activeess"));
                const slideGroup = document.querySelectorAll("#productThumbnails .productThumbnailItem");
                slideGroup[this.activeIndex]?.classList.add("active");
              const thumbnails = document.querySelectorAll("#productThumbnails .productThumbnailItem.matched-variant-thumb");
              const nextThumbnail = thumbnails[this.activeIndex - 1];
              nextThumbnail.classList.add("activeess");
            }
        }
    });

productPage.querySelectorAll(".productThumbnail").forEach(function (element) {
  element.addEventListener("click", function () {
  const matchedThumb = this.closest(".matched-variant-thumb");
    if (matchedThumb) {
      const matchedThumbs = Array.from(document.querySelectorAll(".matched-variant-thumb"));
      const index = matchedThumbs.indexOf(matchedThumb) + 1;
      productImages.slideTo(index);
    }else{
       productImages.slideTo(0);
    }
  });
});

}  
const intervalId = setInterval(() => {
    const pdpCarousel = document.querySelector('.productThumbnailItem.matched-variant-thumb');
    if (pdpCarousel) {
        clearInterval(intervalId);
        setTimeout(() => {
         window.swiperScriptInitialization();
        }, 200);
    }
}, 200);
}
// videos
document.querySelectorAll('.productSwiperPlay').forEach(playWrapper => {
    playWrapper.addEventListener('click', async function () {
        const video = this.querySelector('video');
        if (video) {
            if (this.classList.contains('active')) {
                await video.pause();
                this.classList.remove('active');
            } else {
                await video.play();
                this.classList.add('active');
            }
        }
    });
});


/**************
 -- Tabs
 ***************/

// tab section
const productTabs = productPage.querySelector('#productTabs');

// each tab title, reveal and hide related info
productPage.querySelectorAll('.productTabsItemButton')?.forEach(button => {
    button.addEventListener('click', function () {

        //stop any videos
        if (productTabs?.querySelector('.productTabsItemVideo.active')) {
            productTabs.querySelectorAll('.productTabsItemVideo.active').forEach(el => {
                el.classList.remove('active');
                el.querySelector("video").pause();
            })
        }

        this.classList.toggle('active');
    })
})

// make sure there is at least one video
if (productTabs?.querySelector('.productTabsItemVideo')) {
// play videos on tabs
    productTabs.querySelectorAll('.productTabsItemVideo').forEach(el => {
        el.addEventListener('click', async function () {
            if (this.classList.contains('active')) {
                // pause this one
                this.classList.remove('active');
                await this.querySelector("video").pause();
            } else {
                // stop all videos
                if (productTabs.querySelector('.productTabsItemVideo.active')) {
                    productTabs.querySelectorAll('.productTabsItemVideo.active').forEach(el => {
                        el.classList.remove('active');
                        el.querySelector("video").pause();
                    })
                }
                // play this one
                this.classList.add('active');
                await this.querySelector("video").play();
            }
        })
    })
}

/**************
 -- Modals
 ***************/

// get BNPL modal
const bnplModal = document.querySelector('.bnpl');

// get Shipping Notice modal
const shippingNoticeModal = productPage.querySelector('#shippingNotice');

// get notification modal
const notificationModal = productPage.querySelector('#notification');

// BNPL Modal
productPage.querySelector('.productShippingItem.bnpl')?.addEventListener('click', () => {
    openModal(bnplModal);
})

// Shipping Notice Modal
productPage.querySelectorAll('.productShippingItem.shipping')?.forEach(el => {
    el.addEventListener('click', () => {
        openModal(shippingNoticeModal);
    })
})

// notification form submission
notificationModal?.querySelector('#notificationForm')?.addEventListener("submit", async function (e) {
    e.preventDefault();

    // confirm everything is provided
    let valid = true;
    this.querySelectorAll('[name]').forEach(function (element) {
        if (!element.value) {
            valid = false;
        }
    });

    if (!valid) {
        alert('Please make sure you fill out all fields.');
        return;
    }

    // validate email
    const emailCheck = validateEmail(this.querySelector('#email').value);
    if (!emailCheck) return;

    // start loading
    this.querySelector('button').classList.add('loading');

    // send KlaviyoBackInStockRequest
    sendKlaviyoBackInStockRequest(this.querySelector('#email').value, activeVariant.id);

    // check for newsletter opt in
    if (document.querySelector("#notificationLabelCheck").checked) {
        // add to newsletter
        fetch("https://api.maltertech.com/jadore/newsletter.php", {
            method: "POST",
            body: new URLSearchParams({
                email: this.querySelector('#email').value,
                store: Shopify.shop,
            })
        });
    }

    // end loading
    this.querySelector('button').classList.remove('loading');
    this.classList.add('success');

    // swap content and add close to new button
    this.closest('#notificationInner').classList.add('success');
    notificationModal.querySelector('#notificationBtnConfirmed')?.addEventListener('click', () => {
        notificationModal.close();
    })
})

/****************
 -- Update Product
 *****************/

productPage.querySelectorAll('input').forEach(input => {
    if (input.classList.contains('colorSelectorMobileVariantsItemInput')) return;
    if (input.classList.contains('productAddonsItemCheckInput')) return;
    input.addEventListener('change', () => {
        updateProduct(this.selectedIndex)
            .catch(e => console.error(e));
    });
})

productPage.querySelectorAll('select').forEach(select => {
    if (select.classList.contains('productAddonsItemSelect')) return;
    if (select.classList.contains('productAddonsItemDialogSelect')) return;
    select.addEventListener('change', function () {
        // update the display to match select option
        document.querySelectorAll('.productOptionsItemValuesColorLayoutItem.active')?.forEach(item => item.classList.remove('active'));
        document.querySelector(`.productOptionsItemValuesColorLayoutItem[data-index="${this.selectedIndex}"]`)?.classList.add('active');
        // update the mobile text display
        productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicatorItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorSelectMobileIndicatorItem[data-index="${this.selectedIndex}"]`)?.classList.add('active');
        updateProduct(this.selectedIndex)
            .catch(e => console.error(e));
    });
})

// variant color images
productPage.querySelectorAll('.productOptionsItemValuesColorLayoutItem')?.forEach(item => {
    item.addEventListener('click', function () {
        if (this.classList.contains('active')) return;
        // update the display color
        this.closest('.productOptionsItemValuesColorLayout')
            .querySelectorAll('.productOptionsItemValuesColorLayoutItem.active')
            .forEach(el => el.classList.remove('active'));
        this.classList.add('active');
        
        // update the select option - specifically target the hidden select
        const hiddenSelect = this.closest('.productOptionsItem').querySelector('select#hiddenSelect');
        if (hiddenSelect) {
            hiddenSelect.selectedIndex = this.dataset.index;
            hiddenSelect.dispatchEvent(new Event('change'));
        }
    });
})

// mobile select
productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicator').forEach(el => {
    el.addEventListener('click', function () {
        openModal(productPage.querySelector('.colorSelectorMobile'));
    })
})

// mobile select
productPage.querySelectorAll('.colorSelectorMobileVariantsItemInput').forEach(input => {
    input.addEventListener('change', function () {
        // activate the hidden select option via the color displays
        productPage.querySelectorAll('.productOptionsItemValuesColorLayoutItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorLayoutItem[data-index="${this.dataset.index}"]`)?.click();
        // update the mobile text display
        productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicatorItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorSelectMobileIndicatorItem[data-index="${this.dataset.index}"]`).classList.add('active');
        // close the dialog
        productPage.querySelector('.colorSelectorMobile').close();
    })
})

// mobile close
productPage.querySelectorAll('.colorSelectorMobileTopExit')?.forEach(exit => {
    exit.addEventListener('click', function () {
        this.closest('.colorSelectorMobile')?.close()
    })
})
const DEBUG_LOG = false;

function dbg(...args) {
  if (!DEBUG_LOG) return;
  console.log(...args);
}

function getActiveSwatch() {
  return productPage.querySelector(".productOptionsItemValuesColorLayoutItem.active");
}

function getAllSwatches() {
  return Array.from(productPage.querySelectorAll(".productOptionsItemValuesColorLayoutItem"));
}

function resolveColourFromUI() {
  const swatch = getActiveSwatch();
  if (swatch?.dataset?.color) return swatch.dataset.color.trim();

  // fallback: your dropdown selected-option span logic (if present)
  const dropdownText = productPage.querySelector(".custom-dropdown .selected-option span")?.textContent?.trim();
  if (dropdownText) return dropdownText;

  return null;
}

function resolveSizeFromUI() {
  // try selects first (size dropdown)
  const selects = Array.from(productPage.querySelectorAll("select")).filter(s => {
    if (s.classList.contains("productAddonsItemSelect")) return false;
    if (s.classList.contains("productAddonsItemDialogSelect")) return false;
    if (s.id === "hiddenSelect") return false; // your colour select
    return true;
  });

  for (const s of selects) {
    const v = (s.value || "").trim();
    if (v) return v;
  }

  // fallback: any checked radios/inputs with a value that looks like size
  const checked = Array.from(productPage.querySelectorAll("input:checked")).filter(i => {
    if (i.classList.contains("colorSelectorMobileVariantsItemInput")) return false;
    if (i.classList.contains("productAddonsItemCheckInput")) return false;
    return true;
  });

  for (const i of checked) {
    const v = (i.value || "").trim();
    if (v) return v;
  }

  return null;
}

/**
 * IMPORTANT:
 * This maps "Copper" swatch to the correct variant by looking up which variant belongs to swatch index.
 * Your swatch has data-index="8" which is the colour index, not the variant index.
 * We find variants that represent that colour by comparing against the hidden select option text.
 */
function resolveVariantFromNamedOptions() {
  if (!Array.isArray(product.options) || product.options.length === 0) return null;

  const optionValues = [];

  for (const optionName of product.options) {
    const controls = Array.from(productPage.querySelectorAll('select, input')).filter(el => {
      if (el.name !== optionName) return false;
      if (el.classList.contains('productAddonsItemSelect')) return false;
      if (el.classList.contains('productAddonsItemDialogSelect')) return false;
      if (el.classList.contains('productAddonsItemCheckInput')) return false;
      if (el.classList.contains('rebuy-select')) return false;
      if (el.classList.contains('rebuy-size-input')) return false;
      return true;
    });

    const checked = controls.find(el => el.matches('input') && el.checked);
    const selected = controls.find(el => el.matches('select'));
    const value = (checked?.value || selected?.value || '').trim();

    if (!value) return null;
    optionValues.push(value);
  }

  const matched = product.variants.find(variant => {
    return JSON.stringify(variant.options) === JSON.stringify(optionValues);
  });

  dbg('🧭 resolved named options:', optionValues, matched ? { id: matched.id, title: matched.title } : null);
  return matched || null;
}

function normaliseOptionValue(value) {
  return String(value || "").trim().toLowerCase();
}

function getProductOptionNames() {
  return Array.isArray(product.options) ? product.options.map(optionName => String(optionName || '').trim()) : [];
}

function getProductOptionIndex(matchFn) {
  return getProductOptionNames().findIndex(optionName => matchFn(optionName));
}

function getVariantOptionValue(variant, optionIndex) {
  if (!variant || optionIndex < 0) return "";
  return String(variant.options?.[optionIndex] || variant[`option${optionIndex + 1}`] || "").trim();
}

function resolveVariantFromSwatchAndSize() {
  const swatch = getActiveSwatch();
  const colour = resolveColourFromUI();
  const size = resolveSizeFromUI();
  const hiddenSelect = productPage.querySelector('select#hiddenSelect');
  let shopifyColourKey = null;

  if (hiddenSelect && swatch?.dataset?.index != null) {
    const idx = Number(swatch.dataset.index);
    const opt = hiddenSelect.options?.[idx];
    shopifyColourKey = (opt?.value || opt?.textContent || "").trim();
  }

  if (!shopifyColourKey && swatch) {
    shopifyColourKey = (swatch.getAttribute('title') || swatch.getAttribute('aria-label') || swatch.textContent || "").trim();
  }

  if (!shopifyColourKey && colour) shopifyColourKey = colour;

  const optionNames = Array.isArray(product.options) ? product.options.map(option => String(option || '').trim()) : [];
  const optionValuesFor = variant => Array.isArray(variant.options)
    ? variant.options
    : [variant.option1, variant.option2, variant.option3].slice(0, optionNames.length);
  const normalize = value => String(value || '').trim();
  const selectedByIndex = Array(optionNames.length).fill(null);

  if (shopifyColourKey) {
    let colourIndex = optionNames.findIndex(name => /^colou?r$/i.test(name));

    if (colourIndex === -1) {
      colourIndex = optionNames.findIndex((name, index) => {
        return product.variants.some(variant => normalize(optionValuesFor(variant)[index]) === shopifyColourKey);
      });
    }

    if (colourIndex !== -1) selectedByIndex[colourIndex] = shopifyColourKey;
  }

  if (size) {
    const sizeIndex = optionNames.findIndex((name, index) => {
      if (selectedByIndex[index]) return false;
      return product.variants.some(variant => normalize(optionValuesFor(variant)[index]) === normalize(size));
    });

    if (sizeIndex !== -1) selectedByIndex[sizeIndex] = normalize(size);
  }

  const candidates = product.variants.filter(variant => {
    const values = optionValuesFor(variant).map(normalize);
    return selectedByIndex.every((selectedValue, index) => {
      return !selectedValue || values[index] === selectedValue;
    });
  });

  dbg("🎨 resolveColourFromUI:", colour);
  dbg("📦 resolveSizeFromUI:", size);
  dbg("🟦 active swatch:", swatch ? swatch.dataset : null);
  dbg("🔑 selected option map:", selectedByIndex);
  dbg("🧩 candidate variants:", candidates.map(v => ({ id: v.id, option1: v.option1, option2: v.option2, option3: v.option3, title: v.title })));

  if (candidates.length === 0) return null;
  return candidates[0];
}
function setActiveVariantImagesByName(variantName) {
  if (!variantName) return;

  // MAIN SWIPER
  const swiperImages = document.querySelectorAll(".productSwiperImageVariant");
  let activated = false;

  swiperImages.forEach(img => {
    const alt = img.getAttribute("alt");

    if (!activated && alt === variantName) {
      img.classList.add("active");
      activated = true;
    } else {
      img.classList.remove("active");
    }
  });

  // THUMBNAILS
  const thumbImages = document.querySelectorAll(
    "#productThumbnails img.productThumbnail.variant"
  );

  activated = false;

  thumbImages.forEach(img => {
    const alt = img.getAttribute("alt");

    if (!activated && alt === variantName) {
      img.classList.add("active");
      activated = true;
    } else {
      img.classList.remove("active");
    }
  });
}



async function updateProduct(index = null) {
  if (DEBUG_LOG) {
    console.group("🔁 updateProduct");
    console.log("passed index:", index);
    console.log("current URL variant:", new URL(window.location.href).searchParams.get("variant"));
  }

  let nextVariant = null;

  // Colour/swatch products must keep the swatch resolver in charge.
  // The generic named-option resolver is for non-colour option products such as Replacement Tapes
  // (Size + Adhesive Strength). Running it first on swatch products can desync the visual shade
  // selection from the ATC variant and fall back to the first/default shade.
  const hasColourOption = Array.isArray(product.options) && product.options.some(optionName => {
    return /^colou?r$/i.test(String(optionName || '').trim());
  });
  const hasSwatchUI = !!productPage.querySelector('.productOptionsItemValuesColorLayoutItem, .colorSelectorMobileVariantsItemInput, select#hiddenSelect');

  if (hasSwatchUI) {
    nextVariant = resolveVariantFromSwatchAndSize() || resolveVariantFromNamedOptions();
  } else {
    nextVariant = resolveVariantFromNamedOptions() || resolveVariantFromSwatchAndSize();
  }

  if (nextVariant) {
    activeVariant = nextVariant;
    dbg("✅ resolved activeVariant from swatch+size:", { id: activeVariant.id, title: activeVariant.title, option1: activeVariant.option1, option2: activeVariant.option2 });
  } else {
    dbg("⚠️ swatch+size resolve failed, falling back to old options matching");

    // fallback: original behaviour
    if (product.variants.length === 1) {
      activeVariant = product.variants[0];
    } else {
      let options = [];

      productPage.querySelectorAll("select")?.forEach(select => {
        if (select.classList.contains("productAddonsItemSelect")) return;
        if (select.classList.contains("productAddonsItemDialogSelect")) return;
        options.push(select.value);
      });

      productPage.querySelectorAll("input:checked")?.forEach(input => {
        if (input.classList.contains("colorSelectorMobileVariantsItemInput")) return;
        if (input.classList.contains("productAddonsItemCheckInput")) return;
        options.push(input.value);
      });

      dbg("resolved UI options:", options);

      activeVariant = product.variants.find(variant => {
        return (
          JSON.stringify(variant.options) === JSON.stringify(options) ||
          JSON.stringify(variant.options) === JSON.stringify([...options].reverse())
        );
      });
    }

    if (!activeVariant) {
      if (index !== null && product.variants[index]) {
        activeVariant = product.variants[index];
      } else {
        activeVariant = product.variants.find(v => v.available) || product.variants[0];
      }
    }
  }

  if (DEBUG_LOG) {
    console.log("🎯 final activeVariant:", {
      id: activeVariant.id,
      title: activeVariant.title,
      options: activeVariant.options,
      option1: activeVariant.option1,
      option2: activeVariant.option2
    });
  }

  // Keep any third-party/button readers in sync with the actual variant used for add-to-cart.
  if (productATCButton && activeVariant?.id) {
    productATCButton.setAttribute("data-id", String(activeVariant.id));
  }

  // Variant Image overlay (your existing logic)
  const colorSelect = productPage.querySelector(".productOptionsItemValuesColorLayoutItem.active");
  if (colorSelect) {
    dbg("active colour tile:", colorSelect.dataset);
    if (colorSelect.dataset.image !== "https://cdn.shopify.com/s/files/1/2597/5920/?width=800") {
      const overlay = document.querySelector("#productSwiperImageOverlay");
      overlay.src = colorSelect.dataset.image;
      overlay.classList.add("active");
    } else {
      document.querySelector("#productSwiperImageOverlay")?.classList.remove("active");
    }
  }

  // Price (existing)
  const compareEl = productPage.querySelector("#productCompare");
  const realEl = productPage.querySelector("#productPrice");

  if (activeVariant.compare_at_price > activeVariant.price) {
    compareEl.textContent = price(activeVariant.compare_at_price * quantity, false);
  } else {
    compareEl.textContent = "";
  }
  realEl.textContent = price(activeVariant.price * quantity, false);

  if (document.querySelector("square-placement")) {
    document.querySelector("square-placement").dataset.amount =
      (activeVariant.price * quantity / 100).toString();
  }

  // ATC (existing)
  if (activeVariant.available) {
    productATCButton.disabled = false;
    productATCButton.removeAttribute("aria-disabled");
    productATCButton.classList.remove("notification");
    productPage.querySelector("#productATCText").textContent = "Add To Cart";
  } else {
    if (isDiscontinuedVariant(activeVariant)) {
      productATCButton.disabled = true;
      productATCButton.setAttribute("aria-disabled", "true");
      productATCButton.classList.remove("notification");
      productATCButton.querySelector("#productATCText").textContent = "Sold Out";
    } else {
      productATCButton.disabled = false;
      productATCButton.removeAttribute("aria-disabled");
      productATCButton.classList.add("notification");
      productATCButton.querySelector("#productATCText").textContent = "Sold Out - Notify Me";
    }
  }

  // URL update (existing but log only if changed)
  const url = new URL(window.location.href);
  const prev = url.searchParams.get("variant");
  const next = String(activeVariant.id);

  if (prev !== next) {
    url.searchParams.set("variant", next);
    if (DEBUG_LOG) {
      console.warn("🌍 URL UPDATE");
      console.log("previous variant:", prev);
      console.log("new variant:", next);
      console.trace("URL updated from here");
    }
    window.history.replaceState({}, "", url);
  } else {
    dbg("ℹ️ URL unchanged");
  }

const variantNameForImages =
  productPage.querySelector(".custom-dropdown .selected-option span")
    ?.textContent
    ?.trim()
  || activeVariant.option1;

  console.log("DOING THIS ONE")
  console.log(variantNameForImages)

    setActiveVariantImagesByName(variantNameForImages);

  if (DEBUG_LOG) console.groupEnd();
}

// close background overlay when clicked
document.querySelector('#productSwiperImageOverlay').addEventListener('click', function () {
    this.classList.remove('active');
});

// on load, update the product
updateProduct()
    .catch(e => console.error(e));

// incremental and decremental buttons
productPage.querySelector('.productVariantSpecAmountSelector').addEventListener('click', function (e) {
    e.stopPropagation();
    if (e.target.classList.contains('productVariantSpecAmountSelectorLess')) {
        if (quantity === 1) return;
        quantity--;
    } else if (e.target.classList.contains('productVariantSpecAmountSelectorMore')) {
        quantity++;
    } else {
        return;
    }
    this.querySelector('.productVariantSpecAmountSelectorDisplay').textContent = quantity.toString();
    // Only update price and ATC for current variant, do not recalculate variant
    updateProduct(product.variants.findIndex(v => v.id === activeVariant.id)).catch(err => console.error(err));
});

/*******************
 -- Product Addons --
 ********************/

productPage.querySelectorAll('.productAddonsItemDialogOpen')?.forEach(button => {
    button.addEventListener('click', function () {
        openModal(this.closest('.productAddonsItem').querySelector('.productAddonsItemDialog'));
    })
})

productPage.querySelectorAll('.productAddonsItemDialogExit')?.forEach(exit => {
    exit.addEventListener('click', function () {
        this.closest('.productAddonsItemDialog').close();
    })
})

productPage.querySelectorAll('.productAddonsItemSelect')?.forEach(select => {
    select.addEventListener('change', function () {
        addOnImages(this);
        this.closest('.productAddonsItem').querySelector('.productAddonsItemDialogSelect').selectedIndex = this.selectedIndex;
        if (this.value === "unavailable") {
            this.closest('.productAddonsItem').querySelector('.productAddonsItemCheckInput').checked = false;
        }
    })
})

productPage.querySelectorAll('.productAddonsItemDialogSelect')?.forEach(select => {
    select.addEventListener('change', function () {
        addOnImages(this);
        this.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').selectedIndex = this.selectedIndex;
    })
})

function addOnImages(element) {
    const parent = element.closest('.productAddonsItem');
    // item change
    parent.querySelector('.productAddonsItemImage.active').classList.remove('active');
    parent.querySelector(`.productAddonsItemImage[data-index="${element.selectedIndex}"]`).classList.add('active');
    // dialog change
    parent.querySelector('.productAddonsItemDialogImage.active').classList.remove('active');
    parent.querySelector(`.productAddonsItemDialogImage[data-index="${element.selectedIndex}"]`).classList.add('active');
    // uncheck if unavailable
    if (element.value === "unavailable") {
        parent.querySelector('.productAddonsItemCheckInput').checked = false;
    }
}

productPage.querySelectorAll('.productAddonsItemCheckInput')?.forEach(input => {
    input.addEventListener('change', function () {
        if (this.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').value === "unavailable") {
            this.checked = false;
        }
    })
})

/*************
 Product ATC
 ************/

// main product
productATCButton.addEventListener("click", async function () {

    // if an inactive variant is selected, interrupt and open notification form
    if (this.classList.contains('notification')) {
        // open notification Modal
        openModal(notificationModal);
        return;
    }

    let formData;

    // add loading animation
    this.classList.add("loading");

    formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // addons
    productPage.querySelectorAll('.productAddonsItemCheckInput:checked')?.forEach(input => {
        formData.items.push({
            quantity: 1,
            id: +input.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').value,
        })
    })

    // add product
    try {
        const addResult = await addProduct(formData);
        if (!addResult || !Array.isArray(addResult.items)) {
            throw new Error('Unexpected cart response');
        }

        // Reset both the visible selector and the JavaScript state only after
        // Shopify confirms that the requested line items were added.
        quantity = 1;
        const quantityDisplay = productPage.querySelector('.productVariantSpecAmountSelectorDisplay');
        if (quantityDisplay) quantityDisplay.textContent = '1';
    } catch (e) {
        // failed to atc
        console.error(e);
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

/******************
 -- Recently Viewed
 ******************/

// pull recently viewed from local storage and add unless already there
let recentlyViewedStorage = localStorage.getItem("recently-viewed")
// if there is no recently-viewed, create one
const recentlyViewed = recentlyViewedStorage ? JSON.parse(recentlyViewedStorage) : [];
// check if product is already added
const filteredRecent = recentlyViewed.filter(item => item.title !== product.title)
if (filteredRecent.length === recentlyViewed.length) {
    // if not add
    recentlyViewed.push(product)
    // keeping it at the last four viewed
    while (recentlyViewed.length > 4) {
        recentlyViewed.shift()
    }
    localStorage.setItem("recently-viewed", JSON.stringify(recentlyViewed))
}

function getVariantNameFromUrlVariantId() {
  const params = new URLSearchParams(window.location.search);
  const variantId = params.get("variant");
  if (!variantId || !window.product || !Array.isArray(product.variants)) {
    console.log("no variant id or product.variants missing");
    return null;
  }

  const variant = product.variants.find(v => String(v.id) === String(variantId));
  if (!variant) {
    console.log("variant id not found in product.variants:", variantId);
    return null;
  }

  // what you actually need for matching (Colour / option text)
  const name =
    variant.options?.[0] || // usually Colour
    variant.title ||         // fallback
    "";

  console.log("variantId:", variantId);
  console.log("variant object:", variant);
  console.log("resolved variant name:", name);

  return name;
}

getVariantNameFromUrlVariantId();

